import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthCard from "@/components/auth/AuthCard";
import AuthInput from "@/components/auth/AuthInput";
import AuthButton from "@/components/auth/AuthButton";
import AuthLink from "@/components/auth/AuthLink";
import { useAuth, formatAuthError } from "@/context/AuthContext";

const PW_RULE = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;

export default function ResetForm() {
  const { resetPassword } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const token = new URLSearchParams(location.search).get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!token) { setError("This link is invalid or missing a token."); return; }
    if (!PW_RULE.test(password)) {
      setError("Password must be at least 8 characters and include letters and numbers.");
      return;
    }
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setBusy(true);
    try {
      await resetPassword(token, password);
      navigate("/auth/login?reset=success", { replace: true });
    } catch (err) { setError(formatAuthError(err, "This link is invalid or has expired.")); }
    finally { setBusy(false); }
  };

  return (
    <AuthCard
      title="Set a new password"
      subtitle="Choose a password with at least 8 characters, letters and numbers"
      footer={<AuthLink to="/auth/login" testid="reset-form-back-login">Back to login</AuthLink>}
    >
      <form onSubmit={onSubmit}>
        <AuthInput label="New password" type="password" required
          testid="reset-form-input-password" value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="8+ chars, letters + numbers" autoComplete="new-password" />
        <AuthInput label="Confirm new password" type="password" required
          testid="reset-form-input-confirm" value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          placeholder="Repeat password" autoComplete="new-password"
          error={error} />
        <AuthButton type="submit" testid="reset-form-submit" loading={busy}>Update password</AuthButton>
      </form>
    </AuthCard>
  );
}
